import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import TechnicianFinancePage from '../technicians/TechnicianFinancePage';
import TechnicianReports from '../../components/TechnicianReports';
import ComisionReferidosPage from '../finance/ComisionReferidosPage';

// Pestaña combinada: balances de técnicos (cuánto debe/se le debe a cada uno) arriba, el
// detalle de comisiones por instalación en medio, y al final la cuenta de quien trae
// clientes y cobra por cada uno instalado — otra deuda viva que antes se llevaba a mano.
const ComisionesBalancesTab: React.FC = () => (
  <Box>
    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
      Balances de técnicos
    </Typography>
    <TechnicianFinancePage />
    <Divider sx={{ my: 4 }} />
    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
      Detalle de comisiones
    </Typography>
    <TechnicianReports />
    <Divider sx={{ my: 4 }} />
    <ComisionReferidosPage />
  </Box>
);

export default ComisionesBalancesTab;
